export const createReducer = (actionMap, initState) => {
  return (state, action) => {
    const { type, payload } = action;
    const actionHandler = actionMap[type];
    if (process.env.NODE_ENV !== 'production') {
      reducerLogger(state, type, payload, actionHandler);
    }
    return actionHandler ? actionHandler(state, payload) : initState;
  };
};

const reducerLogger = (state, type, payload, actionHandler) => {
  console.group('Reducer');
  console.info(`TYPE: ${type}`);
  console.info(`PAYLOAD`);
  console.info(payload);
  if (actionHandler) {
    console.info(`NEW STATE`);
    console.info(actionHandler(state, payload));
  }
  console.groupEnd();
};
